/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
document.addEventListener('DOMContentLoaded', () => {
  const addToCartButton = document.getElementById('floating-add-to-cart');

  if (addToCartButton) {
    console.log('Floating Add to Cart button found'); // Debugging step

    addToCartButton.addEventListener('click', (event) => {
      event.preventDefault();

      console.log('Simulating main add-to-cart button click'); // Debugging step
      
      // ✅ Find and trigger the main add-to-cart button
      const mainAddToCartButton = document.querySelector('[data-add-to-cart]');
      if (mainAddToCartButton) {
        mainAddToCartButton.click(); 
      } else {
        console.warn('Main add-to-cart button not found');
      }
    });
  } else {
    console.warn('Floating Add to Cart button not found');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const floatingButton = document.getElementById('floating-add-to-cart');
  const mainButton = document.querySelector('[data-add-to-cart]'); // Adjust selector if needed
  const cartDrawer = document.querySelector('cart-drawer, .cart-drawer'); // Adjust selector based on theme

  if (!floatingButton || !mainButton) return;

  function toggleFloatingButton() {
    const mainButtonRect = mainButton.getBoundingClientRect();
    const isMainButtonOffScreen = mainButtonRect.bottom <= 0; // Button is completely out of view
    const isCartOpen = cartDrawer && cartDrawer.classList.contains('is-open'); // Check if cart drawer is open

    if (isCartOpen || !isMainButtonOffScreen) {
      floatingButton.style.opacity = '0';
      floatingButton.style.pointerEvents = 'none';
      floatingButton.style.transform = 'translateY(100%)'; // Hide button
    } else {
      floatingButton.style.opacity = '1';
      floatingButton.style.pointerEvents = 'auto';
      floatingButton.style.transform = 'translateY(0)'; // Show button
    }
  }

  // Run on page load and on scroll
  toggleFloatingButton();
  window.addEventListener('scroll', toggleFloatingButton);

  // Also check when the cart opens/closes
  const observer = new MutationObserver(toggleFloatingButton);
  if (cartDrawer) {
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }
});

 

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
